export default {
  props: {
    onDone: Function
  },
  methods: {
    async onSubmitDone(e) {
      await this.$validator.validateAll();
      console.log('error onSubmitDone', this.errors.any(), this.errors);
      if (this.errors.any()) return;
      return this.onDone(e, this.shipment);
    }
  }
};
